import type { AgentRow } from "../api/agents";

/**
 * True when a host computer's shared resources (files, printers) are
 * definitely unreachable — offline, blocked from the network, or uninstalled.
 * `needs_attention` is excluded: the PC is still on; only KraetdNet has issues.
 */
export function isHostUnavailable(agent: AgentRow | null | undefined): boolean {
  if (!agent) return true;
  return (
    agent.status === "offline" ||
    agent.status === "blocked" ||
    agent.status === "uninstalled"
  );
}
